import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
// import FadeIn from 'react-fade-in';
import { IoExpandSharp } from 'react-icons/io5';
import { createUseStyles } from 'react-jss';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
// import Zoom from 'react-medium-image-zoom';
import { useCloudinary } from '../../hooks/use-cloudinary';
import { layoutDefaults } from '../../utils/layout-defaults';
import { ProductImagePlaceholder } from '../product-image-placeholder';

const animate = 'animate__animated animate__fadeIn';

function OrderingImage({ image, analyticsFeatureUseEvent }) {
  const [isZoomed, setIsZoomed] = useState(false);
  const { transform } = useCloudinary();
  const [smallImageLoaded, setSmallImageLoaded] = useState(false);

  const url = useMemo(() => transform(image?.url), [image?.url]);

  const classes = useStyles({ url, isZoomed });

  const handleZoomChange = (shouldZoom) => {
    analyticsFeatureUseEvent('ordering image click');
    setIsZoomed(shouldZoom);
  };

  // useBackButtonEvent(() => {
  //   swal.clickCancel();
  //   return true;
  // }, []);

  return (
    image && (
      <>
        {/* <PrismaZoom locked={!isZoomed}>
            <Image
              src={image?.url}
              rounded={!isZoomed}
              fluid
              className={classes.image}
            />
          </PrismaZoom> */}
        <ControlledZoom
          isZoomed={isZoomed}
          onZoomChange={handleZoomChange}
          classDialog={classes.zoomContainer}
          // overlayBgColorStart="rgba(0, 0, 0, .20)"
          // overlayBgColorEnd="#000"
          // transitionDuration={500}
        >
          {/* {isZoomed && (
            <div className={classes.imageContainer}>
              <FadeIn delay={10}>
                <Image
                  className={classes.fullImage}
                  src={url}
                  rounded={!isZoomed}
                  fluid
                />
              </FadeIn>
              <FadeIn delay={300}>
                <div className={classes.close}>Voltar</div>
              </FadeIn>
            </div>
          )} */}

          {/* {!isZoomed && ( */}
          {/* <FadeIn delay={10}> */}
          <div className={classes.container}>
            {!smallImageLoaded && <ProductImagePlaceholder absolute />}
            <img
              src={url}
              alt=""
              className={classNames(classes.smallImage, animate)}
              onLoad={() => setSmallImageLoaded(true)}
            />

            <IoExpandSharp className={classes.icon} />
          </div>
          {/* </FadeIn> */}
          {/* )} */}

          {/* </PrismaZoom> */}
        </ControlledZoom>
      </>
    )
  );
}

// const imageAdjust = -86;

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    // flexGrow: 1,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',

    // backgroundImage: ({ url }) => `url("${url}")`,
    // width: "100vw",
    // height: "100vw",
    height: '140px !important',

    // height: ""

    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundColor: layoutDefaults.imagePlaceholderColor,

    cursor: 'pointer',

    // padding: 10,
    // marginTop: 16,
    marginBottom: layoutDefaults.smallerVerticalMargin,
    borderRadius: layoutDefaults.radius,

    // border: "1px solid red",
  },
  // imageContainer: {
  //   //   // position: "absolute",
  // },
  zoomContainer: {
    // backgroundColor: 'red',
    // border: '1px solid red',
    // '&[data-rmiz-modal-overlay="hidden"]': {
    //   backgroundColor: 'black',
    //   border: '1px solid red',
    // },
    // '&[data-rmiz-modal-overlay="visible"]': {
    //   backgroundColor: 'black',
    //   border: '1px solid blue',
    // },
  },
  smallImage: {
    cursor: 'pointer',
    maxWidth: '100%',
    objectFit: 'cover',
    touchAction: 'pan-x pan-y',
  },
  // fullImage: {
  //   // position: "absolute",
  //   cursor: 'pointer',
  //   // marginTop: imageAdjust,
  //   // marginBottom: -92,
  //   touchAction: 'pan-x pan-y',
  //   // border: '1px solid red',
  // },
  icon: {
    // flex: 1,
    // alignSelf: "flex-end",
    position: 'absolute',
    color: '#eee',
    fontSize: 30,
    // fontWeight: "bold",
    backgroundColor: '#00000040',
    padding: 2,
    // margin: layoutDefaults.smallerVerticalMargin,
    borderRadius: layoutDefaults.radius,
    right: layoutDefaults.smallerHorizontalMargin,
    bottom: layoutDefaults.smallVerticalMargin,
    // opacity: layoutDefaults.smallOpacity,
    // border: "1px solid green",
  },
  // close: {
  //   display: 'flex',
  //   flexDirection: 'row',
  //   color: 'white',
  //   fontSize: layoutDefaults.fontSize,
  //   justifyContent: 'center',
  //   // opacity: layoutDefaults.opacity,
  //   margin: layoutDefaults.horizontalMargin,
  //   // marginBottom: imageAdjust,
  //   cursor: 'pointer',

  //   // border: "1px solid red",
  // },
});

// OrderingImage.propTypes = {
//   storage: PropTypes.object.isRequired,
// };

export { OrderingImage };
